import React from "react";
import {ReactComponent as PickupProcessSvg} from './../assets/icons/svg/pickup-process.svg';
import {ReactComponent as PickupDoneSvg} from './../assets/icons/svg/pickup-done.svg';
import {ReactComponent as PickupDeclineSvg} from './../assets/icons/svg/pickup-decline.svg';
import {ReactComponent as DeliverySvg} from './../assets/icons/svg/delivery.svg';
import { Image } from "react-bootstrap";
const delivery = require('./../assets/icons/svg/delivery.png');


export default function ListPickup({data, updateStatus, loading}) {
   const formatDate = (date) => {
      let d = new Date(date);
      let day = d.getDate();
      let strArray=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      let month = strArray[d.getMonth()];
      let year = d.getFullYear();
      let time = d.getHours() + ':' + d.getMinutes();
      return day + ' ' + month + ' ' + year + ' ' + time + ' WIB';
   };
   
   return (
      <div style={{paddingTop:'130px'}}>
         {loading ?
         <div>
            <div className="skeleton skeleton-list mb-3"></div>
            <div className="skeleton skeleton-list mb-3"></div>
            <div className="skeleton skeleton-list mb-3"></div>
         </div> :
         <div>
            {data.length > 0 ?
               <div>
                  {data.map((item, key) =>{
                  return(
                     <div className="py-3" key={key}>
                        <div className="d-flex w-100">
                           <div className="item-transaction-icon me-4">
                              {item?.status === 0 || item?.status === 1 ?
                                 <PickupProcessSvg/> :
                                 <div>
                                    {item?.status === 2 ?
                                       <PickupDoneSvg/> :
                                       <PickupDeclineSvg/>
                                    }
                                 </div>
                              }
                           </div>
                           <div className="item-transaction-activities">
                              <div className="mb-1">
                                 <h6 className="mb-0">
                                    Request Penjemputan
                                 </h6>
                              </div>
                              <div className="mb-1">
                                 <small className="text-muted">
                                    <span className="me-2 text-muted">Nama BSU/Mitra : </span>
                                    {item?.partner?.name}
                                 </small>
                              </div>
                              <div className="mb-1">
                                 <small>
                                    <span className="me-2 text-muted">Status :</span> 
                                    {item?.status === 0 ?
                                       <span className="text-danger fw-semibold">Menunggu Konfirmasi</span> :
                                       <span>
                                          { item?.status === 1 ?
                                          <span className="text-success fw-semibold">Dikonfirmasi</span> :
                                          <span>
                                             {item?.status === 2 ?
                                                <span className="text-success fw-semibold">Selesai</span> :

                                                <span>
                                                   {item?.status === 3 ? 
                                                      <span className="text-danger fw-semibold">Dibatalkan Mitra</span> :
                                                      <span className="text-danger fw-semibold">Dibatalkan Anda</span>
                                                   }
                                                </span>
                                             }
                                          </span>
                                          }
                                       </span>
                                    }
                                 </small>
                              </div>
                              {/* {data?.status === 3 ? 
                              <div className="text-muted">
                                 {data?.}
                              </div>
                              } */}
                              {item?.status !== 0 ?
                                 <div className="text-muted d-flex align-items-center">
                                    <span className="me-2">
                                       {item?.status === 1 ?
                                          <small>Estimasi Dijemput : </small> :
                                          <div>
                                             {item?.status === 2 ?
                                                <small className="text-muted">Tanggal Selesai : </small> :
                                                <small className="text-muted">Tanggal Dibatalkan : </small>
                                             }
                                          </div>
                                       }
                                    </span>
                                    <small className="text-muted">{formatDate(item?.created_at)}</small>
                                 </div> : null
                              }
                           </div>
                        </div>
                        <div>
                           {
                              item?.status === 0 &&
                              <button 
                                 type="button"
                                 className="btn btn-sm btn-outline-danger rounded-pill w-100 my-2 p-1"
                                 onClick={() => updateStatus(item?.id,4)}
                              >
                                 Batalkan Permintaan Jemput
                              </button>
                           }
                        </div>
                     </div>
                  )
               })}
               </div> :
               <div className="empty-list flex-column">
                  <Image src={delivery}/>
                  <div className="my-3 text-center text-muted">
                     <small>
                        Ups, belum ada request penjemputan yang dibuat. Ayo buat request penjemputan sekarang.
                     </small>
                  </div>
               </div>
            }
         </div>
         }
      </div>
   );
}